export interface InsertPastedTextResult {
  // Field value after the paste is applied.
  value: string;
  // Caret position right after the inserted text (and its trailing separator).
  caret: number;
}

/**
 * Replace the current selection of a text field with pasted text followed by a space,
 * so consecutive barcode-scanner "pastes" (scanners that emit no Enter suffix) stay
 * separated instead of concatenating into one garbled identifier. The extra space is
 * skipped when the pasted text already ends with whitespace.
 *
 * Kept dependency-free so it can be unit-tested without importing components.
 */
export const insertPastedText = (value: string, pasted: string, selectionStart: number, selectionEnd: number): InsertPastedTextResult => {
  if (!pasted) return { value, caret: selectionEnd }

  const inserted = /\s$/.test(pasted) ? pasted : `${pasted} `
  const nextValue = value.slice(0, selectionStart) + inserted + value.slice(selectionEnd)

  return { value: nextValue, caret: selectionStart + inserted.length }
}
